import { Controller } from "@hotwired/stimulus";
import flatpickr from "flatpickr";
import { useClickOutside } from "stimulus-use";

export default class extends Controller {
  static targets = ["start_date", "end_date", "select_date_container"];
  static classes = ["hidden"];

  connect() {
    const configurations = {
      dateFormat: "Y-m-d",
      altFormat: "F j, Y",
      inline: true,
    };

    this.start_date_picker = flatpickr(this.start_dateTarget, configurations);
    this.end_date_picker = flatpickr(this.end_dateTarget, configurations);

    useClickOutside(this);
  }

  disconnect() {
    if (this.start_date_picker) {
      this.start_date_picker.destroy();
      this.start_date_picker = null;
    }
    if (this.end_date_picker) {
      this.end_date_picker.destroy();
      this.end_date_picker = null;
    }
  }

  toggle() {
    this.select_date_containerTarget.classList.toggle(this.hiddenClass);
  }

  hide() {
    this.select_date_containerTarget.classList.add(this.hiddenClass);
  }

  clickOutside(event) {
    if (!this.element.contains(event.target) && !event.target.closest('[class="date_selector"]')) {
      this.hide();
    }
  }
}
